import MainLayout from "@/components/layout/applicant/MainLayout.vue";
import {
    required,
    minLength,
    sameAs,
} from "vuelidate/lib/validators";
import axios from 'axios';
import store from "../../store";

export default {
    name: "applicantChangePassword",
    components: {
        MainLayout
    },

    data() {
        return {
            password: this.password,
            current_password: this.current_password,
            password_confirmation: this.password_confirmation,
            id: this.$route.params.id,
            submitted: false
        };
    },

    validations: {
        password: {
            required,
            minLength: minLength(6),
        },
        current_password: {
            required,
        },
        password_confirmation: {
            required,
            sameAsPassword: sameAs("password")
        }
    },

    methods: {
        handleSubmit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.changePassword();
        },

        changePassword() {
            var request = {
                password: this.password,
                current_password: this.current_password,
                id: this.id
            };
            axios.post('/applicant/change_password/:id', request)
                .then(response => {
                    console.log("API Success", response.data);
                    store.commit("setApplicantData", null);
                    this.$notification.success('စကားဝှက်ပြောင်းလဲခြင်းအောင်မြင်သည်။', {
                        timer: 3,
                        position: 'bottomCenter'
                    });
                    this.$router.push({
                        name: "applicantLogin"
                    });
                })
                .catch(error => {
                    this.$notification.error("လက်ရှိစကားဝှက် မှားယွင်းနေသည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    console.log("Change Password Client Error", error);
                });
        }
    }
};